var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4797B9;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,6.25C118.06,6.25,6.25,118.06,6.25,256S118.06,505.75,256,505.75c137.92,0,249.75-111.81,249.75-249.75 S393.94,6.25,256,6.25z M256,474.53c-120.69,0-218.53-97.84-218.53-218.53S135.31,37.47,256,37.47S474.53,135.31,474.53,256 S376.69,474.53,256,474.53z M326.8,122.76c-6.1-6.1-15.98-6.1-22.07,0L185.21,242.28c-3.75,3.75-4.9,8.87-4.04,13.72 c-0.86,4.84,0.31,9.97,4.04,13.72l119.52,119.52c6.1,6.09,15.98,6.09,22.07,0c6.1-6.1,6.1-15.98,0-22.07L215.64,256l111.15-111.15 C332.89,138.74,332.89,128.86,326.8,122.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.8e0c663c6be5175853885c2d459ad044.svg";
export { ForwardRef as ReactComponent };